import { axiosInstance } from "../axiosInstance";
import { notify } from "../components/toastify";

// let hasNotified = false;

export const fetchData = async (endpoint, page = 1, search = "") => {
  try {
    let url = `${endpoint}?page=${page}`;
    if (search) {
      url += `&searchParam=${search}`; // Correctly append search parameter
    }

    const response = await axiosInstance.post(url, {});
    // console.log(response.data.data);
    return response.data.data;
  } catch (error) {
    // if (!hasNotified) {
    notify(error.response.data.message || error.message);

    console.log(error.message);
    throw new Error(error.response?.data?.message || error.message);
    // throw new Error("Error fetching data" + error.message);
  }
};

export const fetchOnlyData = async (endpoint) => {
  try {
    let url = `${endpoint}`;

    const response = await axiosInstance.get(url);
    return response?.data?.data;
  } catch (error) {
    // if (!hasNotified) {
    notify(error?.response?.data?.message || error.message);

    console.log(error.message);
    throw new Error(error.response?.data?.message || error.message);
  }
};
export const fetchPinData = async (endpoint) => {
  try {
    let url = `${endpoint}`;

    const response = await axiosInstance.get(url, {});
    notify(response?.data?.message, "success");

    return response;
  } catch (error) {
    // if (!hasNotified) {
    notify(error?.response?.data?.message || error.message);

    throw new Error(error.response?.data?.message || error.message);
    // throw new Error("Error fetching data" + error.message);
  }
};

export const createData = async (endpoint, data, showNotification) => {
  try {
    const response = await axiosInstance.post(`${endpoint}`, data);
    if (showNotification) {
    } else {
      notify(response?.data?.message, "success");
    }

    return response?.data; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const updateData = async (endpoint, id, data, showNotification) => {
  try {
    const response = await axiosInstance.put(`${endpoint}${id}`, data);
    if (showNotification) {
    } else {
      notify(response.data.message, "success");
    }

    return response?.data;
    // Adjust based on the structure of your response
  } catch (error) {
    notify(error?.response?.data?.message || error.message);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const deleteData = async (endpoint, id) => {
  try {
    const response = await axiosInstance.delete(`${endpoint}${id}`);
    // console.log(url);
    notify(response.data.message, "success");
    return response?.data; // Adjust based on the structure of your response
  } catch (error) {
    notify(error?.response?.data?.message || error.message);

    throw new Error(error.response.status);
  }
};

export const getDataById = async (endpoint, id) => {
  try {
    const response = await axiosInstance.get(`${endpoint}${id}`);

    return response; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);

    throw new Error(error.response?.data?.message || error.message);
  }
};
